export class PriceRuleLocationRegionView {
    public regionCode: string;
    public regionName: string;
}